import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import NewAssetItemLite from "./NewAssetItemLite";
import EditAssetItemLite from "./EditAssetItemLite";
import ViewAssetItem from "./ViewAssetItem";
import AssetitemBarcode from "./AssetitemBarcode";
import StatusUpdate from "./StatusUpdate";
import ScheduledCleaningOffcanvas from "./ScheduleCleaning";
import BulkUpdateOffcanvas from "./BulkUpdateOffcanvas";
import { Select, Spin, Button, Modal, Input } from "antd";
import Swal from "sweetalert2";
import { getPermissionsForMenu } from "../../Utils/RolePermissions";
import { getApiBaseUrl, LOGIN } from "../../Config/Config";
import ReplaceRetireDrawer from "./FilterStatusUpdate";

const { Option } = Select;

const AssetItems = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const menuPath = pathSegments[pathSegments.length - 1];
  const { Write, Delete, Export } = getPermissionsForMenu(menuPath);
  const hasActions = Write || Delete || Export;
  const user = JSON.parse(sessionStorage.getItem("user"));
  const UserId = user?.UserID;

  const [barcodeValue, setBarcodeValue] = useState(null);
  const [blocks, setBlocks] = useState([]);
  const [selectedBlock, setSelectedBlock] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);

  const [filtersData, setFiltersData] = useState([]);
  const [loadingFilters, setLoadingFilters] = useState(true);
  const roleId = parseInt(sessionStorage.getItem("selectedRole"));
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [isManualOverride, setIsManualOverride] = useState(false);
  const [isBulkUpdateDrawerVisible, setIsBulkUpdateDrawerVisible] =
    useState(false);
  const [isStatusUpdateDrawerVisible, setIsStatusUpdateDrawerVisible] =
    useState(false);
  const [isReplaceRetireOffcanvasVisible, setIsReplaceRetireOffcanvasVisible] =
    useState(false);

  const [visible, setVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const fetchFilters = async (setFiltersData, setLoadingFilters) => {
    try {
      setLoadingFilters(true);
      const url = `${getApiBaseUrl()}/api/getFiltersList?BlockId=${selectedBlock}&Status=0&Barcode=0`;

      const response = await fetch(url);
      const result = await response.json();
      setFiltersData(result.ResultData || []);
      console.log("Filters fetched:", result.ResultData);
    } catch (err) {
      console.error("Error fetching filters:", err.message);
    } finally {
      setLoadingFilters(false);
    }
  };

  useEffect(() => {
    fetchFilters(setFiltersData, setLoadingFilters);
  }, [selectedBlock]);

  useEffect(() => {
    const fetchBlocks = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/api/getLocationType`);
        const result = await response.json();
        if (result?.ResultData && result?.ResultData?.length > 0) {
          setBlocks(result.ResultData);
          console.log("Blocks fetched:", result.ResultData);
        }
      } catch (err) {
        console.error("Error fetching blocks:", err);
      }
    };
    fetchBlocks();
  }, []);

  const stageColorMap = {
    "Wash-in": "text-info",
    "Wash-out": "text-info",
    "Dry-in": "text-warning",
    "Dry-out": "text-warning",
    "Storage-in": "text-success",
    "Storage-out": "text-success",
    Installation: "text-primary",
    Replacement: "text-primary",
    Retirement: "text-danger",
    Spare: "text-success",
    New: "text-secondary",
  };

  const handleCheckboxChange = (record, checked) => {
    setSelectedIds((prev) => {
      // ✅ If unchecking → just remove, no validation
      if (!checked) {
        return prev.filter((item) => item.Id !== record.Id);
      }

      // ✅ If checking
      if (prev.length === 0) {
        return [record];
      }

      const currentStatus = prev[0].Status;
      const currentAHU = prev[0].AHUId;

      let messages = [];

      if (record?.Status !== currentStatus) {
        messages.push("All selected filters must have the same status");
      }

      if (currentStatus === 6 && record?.AHUId !== currentAHU) {
        messages.push("All selected filters must have the same AHU");
      }

      if (messages.length > 0) {
        Swal.fire({
          icon: "error",
          title: "Invalid Selection",
          html: messages.map((m) => `<p>${m}</p>`).join(""),
          confirmButtonText: "OK",
        });
        return prev;
      }

      if (!prev.some((item) => item.Id === record.Id)) {
        return [...prev, record];
      }

      return prev;
    });
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      if (filtersData.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No Data",
          text: "No filters available to select",
          confirmButtonText: "OK",
        });
        return;
      }

      // Use the status of the first selected record, or the first row if nothing selected
      const referenceStatus =
        selectedIds.length > 0 ? selectedIds[0].Status : filtersData[0].Status;

      // Select all rows matching that status
      const matchingRows = filtersData.filter(
        (item) => item.Status === referenceStatus
      );

      setSelectedIds(matchingRows);
    } else {
      setSelectedIds([]);
    }
  };

  const handleBlockChange = (blockId) => {
    setSelectedBlock(blockId);
    setSelectedIds([]);
    setIsManualOverride(false);
  };

  const handleBarcodeClick = (record) => {
    setBarcodeValue(record);
  };

  const handleDelete = async (record) => {
    console.log("Delete record", record);

    const payload = {
      id: record.Id,
      userId: UserId,
    };

    try {
      const response = await fetch(`${getApiBaseUrl()}/api/deleteFilter`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("Delete response:", result);

      if (result?.ResultData && result.ResultData[0]?.Status === "Success") {
        console.log("Filter deleted:", result.ResultData[0].ResultMessage);

        await Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Filter deleted successfully",
          // result.ResultData[0].ResultMessage || "Filter deleted successfully",
          confirmButtonText: "OK",
        });

        window.location.reload(); // reload only after confirmation
      } else {
        console.error(
          "Delete failed:",
          result?.ResultData?.[0]?.ResultMessage || "Unknown error"
        );

        await Swal.fire({
          icon: "error",
          title: "Failed",
          text:
            result?.ResultData?.[0]?.ResultMessage ||
            "Failed to delete filter.",
        });
      }
    } catch (error) {
      console.error("Error deleting filter:", error);

      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while deleting the filter.",
      });
    }
  };

  const handlePasswordSubmit = async () => {
    if (!password) {
      setPasswordError("Please enter your password");
      return;
    }

    setLoading(true);
    setPasswordError("");

    const username = user?.UserName || user?.Username;
    let loginSuccessful = false;

    try {
      const loginRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const loginData = await loginRes.json();

      if (loginData?.Message === "Login successful") {
        loginSuccessful = true;
      } else {
        setPasswordError(
          "Reauthentication failed. Please check your password."
        );
      }
    } catch (error) {
      console.error(error);
      setPasswordError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      if (loginSuccessful) {
        setVisible(false);
        setPassword("");
        handleDelete(selectedRecord);
      }
    }
  };

  const columns = [
    {
      title: "Block",
      dataIndex: "locatinname",
      key: "locatinname",
      sorter: (a, b) => a.locatinname.localeCompare(b.locatinname),
    },
    {
      title: "AHU ID",
      dataIndex: "AHUcode",
      key: "AHUcode",
      sorter: (a, b) => a.AHUcode.localeCompare(b.AHUcode),
    },
    {
      title: "Filter ID",
      dataIndex: "Lable",
      key: "Lable",
      sorter: (a, b) => a.Lable.localeCompare(b.Lable),
      render: (text, record) => {
        let dotColor = "bg-secondary";
        const status = record.Status;

        if (status === 1) dotColor = "bg-success";
        else if (status === 2) dotColor = "bg-warning";
        else if (status === 3) dotColor = "bg-info";

        return (
          <Link
            to="#"
            onClick={() => setViewData(record)}
            title={text}
            className="d-flex align-items-center gap-2"
          >
            <span
              className={`rounded-circle ${dotColor}`}
              title={record.StageName || "Unknown"}
              style={{
                width: "10px",
                height: "10px",
                display: "inline-block",
              }}
            ></span>
            {text}
          </Link>
        );
      },
    },
    {
      title: "Filter Type",
      dataIndex: "AssetTypename",
      key: "AssetTypename",
      sorter: (a, b) => a.AssetTypename.localeCompare(b.AssetTypename),
    },
    // {
    //   title: "Installed on",
    //   dataIndex: "InstalledOn",
    //   key: "InstalledOn",
    //   sorter: (a, b) => new Date(a.InstalledOn) - new Date(b.InstalledOn),
    //   render: (date) => {
    //     if (!date) return "";
    //     const d = new Date(date);
    //     const day = String(d.getDate()).padStart(2, "0");
    //     const month = String(d.getMonth() + 1).padStart(2, "0");
    //     const year = d.getFullYear();
    //     const hours = String(d.getHours()).padStart(2, "0");
    //     const minutes = String(d.getMinutes()).padStart(2, "0");
    //     return `${day}/${month}/${year} ${hours}:${minutes}`;
    //   },
    // },

    {
      title: "Last Cleaning",
      dataIndex: "LastCleaningDate",
      key: "LastCleaningDate",
      sorter: (a, b) =>
        new Date(a.LastCleaningDate) - new Date(b.LastCleaningDate),
      render: (text) => {
        if (!text) return "NA"; // handle null/empty case

        const date = new Date(text);
        const pad = (n) => (n < 10 ? "0" + n : n);

        const day = pad(date.getUTCDate());
        const month = pad(date.getUTCMonth() + 1);
        const year = date.getUTCFullYear();

        if (year < 2000) {
          return "NA";
        }

        return `${day}/${month}/${year}`;
      },
    },

    {
      title: "Status",
      dataIndex: "StageName",
      key: "StageName",
      fixed: "right",
      sorter: (a, b) => a.StageName.localeCompare(b.StageName),
      render: (stageName) => {
        const cleanStage = stageName;
        const textColor = stageColorMap[cleanStage] || "text-secondary";
        return <span className={`fw-semibold ${textColor}`}>{cleanStage}</span>;
      },
    },
  ];

  if (hasActions && selectedIds?.length < 2) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action d-flex align-items-center">
            {Export && (
              <Link
                to="#"
                className="me-2 p-2"
                onClick={() => handleBarcodeClick(record)}
                data-bs-toggle="offcanvas"
                data-bs-target="#AssetitemBarcode"
                title="View Barcode"
              >
                <i className="fa fa-barcode text-dark"></i>
              </Link>
            )}
            {Write && (
              <Link
                to="#"
                className="me-2 p-2"
                onClick={() => {
                  setSelectedAsset(record);
                  setIsStatusUpdateDrawerVisible(true);
                }}
                title="Update Status"
              >
                <i className="fa fa-wrench text-success"></i>
              </Link>
            )}
            {Write && (
              <Link
                to="#"
                className="me-2 p-2"
                onClick={() => setSelectedAsset(record)}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightEditFilterAsset"
                title="Edit"
              >
                <i data-feather="edit" className="feather-edit text-info"></i>
              </Link>
            )}
            {Write && (
              <Link
                to="#"
                className="me-2 p-2"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedAsset(record);
                  setIsReplaceRetireOffcanvasVisible(true);
                }}
                title="Replace or Retire"
              >
                <i className="fa fa-exchange-alt text-warning"></i>
              </Link>
            )}
            {Write && (
              <div className="d-none">
                <Link
                  to="#"
                  className="me-2 p-2"
                  title="Delete filter"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedRecord(record);
                    setVisible(true);
                  }}
                >
                  <i
                    data-feather="trash"
                    className="feather-trash text-danger"
                  ></i>
                </Link>
              </div>
            )}
          </div>
        </div>
      ),
    });
  }
  const checkboxColumn = {
    title: (
      <input
        id="select-all-checkbox"
        type="checkbox"
        checked={
          selectedIds.length > 0 &&
          selectedIds.length ===
            filtersData.filter(
              (item) =>
                item.Status ===
                (selectedIds[0]?.Status ?? filtersData[0]?.Status)
            ).length
        }
        onChange={(e) => handleSelectAll(e.target.checked)}
      />
    ),
    dataIndex: "select",
    key: "select",
    width: 50,
    render: (_, record) => (
      <input
        type="checkbox"
        checked={selectedIds.some((item) => item.Id === record.Id)}
        onChange={(e) => handleCheckboxChange(record, e.target.checked)}
      />
    ),
  };
  useEffect(() => {
    const checkbox = document.getElementById("select-all-checkbox");
    if (checkbox) {
      checkbox.indeterminate =
        selectedIds.length > 0 &&
        selectedIds.length <
          filtersData.filter(
            (item) =>
              item.Status === (selectedIds[0]?.Status ?? filtersData[0]?.Status)
          ).length;
    }
  }, [selectedIds, filtersData]);

  const finalColumns =
    roleId === 4 && selectedBlock !== 0
      ? [checkboxColumn, ...columns]
      : columns;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item" aria-current="page">
                    Filters List
                  </h4>
                </ol>
              </nav>
              <h6>Manage Filters</h6>
            </div>
          </div>
          {Write && (
            <div className="page-btn">
              <Link
                to="#"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightNewFilterAsset"
                className="btn btn-success btn-sm"
              >
                <i className="ti ti-circle-plus fs-4"></i>
              </Link>
            </div>
          )}
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set m-3"></div>
            <div className="d-flex align-items-center flex-wrap gap-3 my-xl-auto right-content">
              <div style={{ minWidth: "250px" }}>
                <label className="fw-bold mb-1 d-block">Select Block:</label>
                <Select
                  style={{ width: "100%" }}
                  value={selectedBlock === 0 ? 0 : selectedBlock}
                  onChange={handleBlockChange}
                  placeholder="Select Block"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  <Option key={0} value={0}>
                    All
                  </Option>
                  {blocks.map((block) => (
                    <Option key={block.BlockId} value={block.BlockId}>
                      {block.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>
              {selectedIds.length > 1 && (
                <div style={{ minWidth: "150px" }}>
                  <label className="fw-bold mb-1 d-block">&nbsp;</label>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => setIsBulkUpdateDrawerVisible(true)}
                  >
                    Bulk Update
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loadingFilters ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : filtersData?.length > 0 ? (
                <Table columns={finalColumns} dataSource={filtersData} />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <NewAssetItemLite />
      <StatusUpdate
        selectedAsset={selectedAsset}
        selectedBlock={selectedBlock}
        visible={isStatusUpdateDrawerVisible}
        onClose={() => setIsStatusUpdateDrawerVisible(false)}
      />
      <EditAssetItemLite formData={selectedAsset} />
      <ViewAssetItem formData={viewData} />
      <AssetitemBarcode barcodeValue={barcodeValue} />
      <ScheduledCleaningOffcanvas />
      <ReplaceRetireDrawer
        selectedAsset={selectedAsset}
        selectedBlock={selectedBlock}
        visible={isReplaceRetireOffcanvasVisible}
        onClose={() => setIsReplaceRetireOffcanvasVisible(false)}
      />
      <BulkUpdateOffcanvas
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        fetchFilters={fetchFilters}
        setFiltersData={setFiltersData}
        setLoadingFilters={setLoadingFilters}
        selectedBlock={selectedBlock}
        isManualOverride={isManualOverride}
        setIsManualOverride={setIsManualOverride}
        visible={isBulkUpdateDrawerVisible}
        onClose={() => {
          setIsBulkUpdateDrawerVisible(false);
          setIsManualOverride(false);
        }}
      />

      <Modal
        title="Confirm Password"
        open={visible}
        onOk={handlePasswordSubmit}
        onCancel={() => setVisible(false)}
        confirmLoading={loading}
        width={350}
      >
        <Spin spinning={loading}>
          <Input.Password
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            onCopy={(e) => e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
            onCut={(e) => e.preventDefault()}
          />
          {passwordError && (
            <div className="text-danger mt-2">{passwordError}</div>
          )}
        </Spin>
      </Modal>
    </div>
  );
};

export default AssetItems;
